import React from "react";
import { Outlet } from "react-router-dom";

import css from "./content.module.css";

export const Content = (props) => {
  return (
    <>
      <div className={css.container}>
        <div></div>
        {props.component}
        <Outlet />
        <div></div>
      </div>
    </>
  );
};
